/** English Nutri-Matic device labels. Brands stay in English per product copy rules. */
export const enNutrimaticLabels = {
  productName: 'Nutri-Matic Synthesizer',
  edition: 'v42.0 · Heart of Gold edition',
  dontPanic: "DON'T PANIC",
  online: 'Online',
  selectionBay: 'Selection bay',
  reagentCatalog: 'Token catalog · live',
  marketQuote: 'Market quote',
  readoutConsole: 'Synthesizer console',
  marketSpotRate: 'Market rate',
  executionRate: 'Execution rate',
  viewportPurpose: 'Display mode',
  viewportPurposeShort: {
    market: 'Market',
    'transaction-confirm': 'Confirm',
    'transaction-signing': 'Sign',
    'transaction-broadcast': 'Sending',
    'transaction-success': 'Success',
    'transaction-error': 'Error',
  },
  transactionPreviewHint: 'Enter valid amounts to preview the transaction.',
  quote: 'Quote',
  marketChart: 'Market chart',
  synthesisCore: 'Swap panel',
  synthesisYouPay: 'You pay',
  synthesisYouReceive: 'You receive',
  changePatch: 'Change pair',
  confirmPair: 'Confirm pair',
  backToQuote: 'Quote',
  inputChamber: 'Input token',
  outputChamber: 'Output token',
  dispenseAction: 'Confirm swap',
  synthesisDeckMode: 'Combined view',
  synthesisLayout: 'Panel layout',
  synthesisLayoutShort: {
    displays: 'Displays',
    combined: 'Combined',
  },
  synthesisRate: 'Exchange rate',
  hyperspaceReady: 'Ready to trade',
  activePair: 'Active pair',
  selectReagentsHint: 'Choose tokens in the selection bay',
  pairsTab: (count: number) => `Pairs (${count})`,
  tokensTab: 'Tokens',
  pairLoaded: 'Selected',
  pairsPanelHint: 'Tap a pair to use it in the swap',
  tokensPanelHint: 'Choose each token separately',
  searchPair: 'Search pair…',
  searchPairCompact: 'Search pair…',
  searchToken: 'Search token or address…',
  searchTokenCompact: 'Search token…',
  stepSelectPay: 'Step 1/2 — choose the token you pay with',
  stepSelectReceive: 'Step 2/2 — choose the token you receive',
  stepPayLocked: (symbol: string) => `(paying with ${symbol})`,
  pairReadyHint: 'Pair ready — tap any token to start over',
  frequentTokens: 'Frequently used',
  allKnownTokens: 'All known tokens',
  chooseTokensManually: 'Choose tokens manually →',
  controlPanel: 'Control panel',
  physicalControls: 'Controls',
  availableBalance: 'Available',
  marketsBay: 'Pairs',
  toggleChart: 'Chart',
  exitDevice: 'Exit',
  settingsBay: 'Swap settings',
  transactionBay: 'Swap confirmation',
  transactionReview: 'Review swap',
  transactionSigning: 'Waiting for wallet signature',
  transactionBroadcast: 'Sending transaction',
  transactionComplete: 'Swap completed',
  transactionError: 'Transaction error',
  priceUpdated: 'Price updated',
  acceptPrice: 'Accept price',
  confirmDispense: 'Confirm swap',
  confirmAnyway: 'Confirm anyway',
  cancel: 'Cancel',
  backToSynthesis: 'Back to swap',
  mobileSimple: {
    productBrand: 'Nutri-Matic',
    swapTitle: 'Swap',
    reviewScreenTitle: 'Review',
    convertTitle: 'Swap',
    reviewTitle: 'Swap summary',
    reviewUnavailable:
      'There is no valid quote to review. Adjust the amount and try again.',
    reviewSwap: 'Review swap',
    from: 'From',
    to: 'To',
    continue: 'Continue',
    convert: 'Swap',
    connectWallet: 'Connect wallet',
    pickPayAsset: 'Which token do you want to swap?',
    pickReceiveAsset: 'Which token do you want to receive?',
    searchAssets: 'Search assets',
    pickerSearchPlaceholder: 'Search by symbol or contract address',
    pickerFeatured: 'Featured',
    pickerAll: 'All',
    pickerWithBalance: 'With balance',
    pickerWithoutBalance: 'Without balance',
    pickerResults: 'Results',
    pickerImportAndSelect: 'Import and select',
    pickerImportedBadge: 'Imported',
    pickerRemoveImported: 'Remove from my list',
    pickerSearchingContract: 'Searching contract…',
    pickerAddressNotFound: 'No token at this address.',
    pickerContractFoundTitle: 'Contract found',
    pickerContractFoundLead:
      "This token exists on-chain, but it is not part of Don't Panic's official catalog.",
    pickerContractFoundHint:
      'Import it to add it to your personal list and trade it in swap, liquidity, and other actions.',
    pickerContractImport: 'Import token',
    pickerCancelSearch: 'Cancel',
    pickerClearSearch: 'Clear search',
    clearAmounts: 'Clear amounts',
    safeMaxPreset: 'Safe max',
    pickerContractAddressLabel: 'Contract',
    pickerContractDecimalsLabel: 'Decimals',
    pickerContractCatalogLabel: 'Catalog',
    pickerNotInCatalog: 'Off catalog',
    pickerContractDecimals: (decimals: number) => `${decimals} decimals`,
    pickerNoResults: 'No assets found',
    pickerNoResultsTitle: 'No assets found',
    pickerNoResultsLead: 'Try another symbol, name, or contract address.',
    pickerAddressNotFoundTitle: 'Contract not found',
    pickerConnectWalletHint: 'Connect your wallet to see your balances.',
    pickerEmptyWithBalance: 'No catalog assets have balance in your wallet.',
    pickerBalanceAmount: (amount: string, symbol: string) => `${amount} ${symbol}`,
    balance: 'Balance',
    balanceAmount: (amount: string, symbol: string) => `${amount} ${symbol}`,
    approxReceive: (amount: string, symbol: string) => `≈ You will receive ${amount} ${symbol}`,
    priceImpactLabel: 'Impact',
    quoteIdle: 'Enter an amount to see the quote.',
    rateIdle: 'Select a pair to see the exchange rate.',
    invertRate: 'Invert quote pair',
    openSettings: 'Swap settings',
    viewPool: 'View liquidity pool',
    poolOffCatalogHint: 'Pool resolved on-chain; it may not be indexed in the market.',
    poolNotDeployedHint: 'This pool is not deployed on-chain yet. You can create liquidity for this pair.',
    successTitle: (from: string, to: string) => `Done! You swapped ${from} for ${to}`,
    successReceived: (amount: string, symbol: string) =>
      `You received ${amount} ${symbol} in your wallet`,
    viewExplorer: 'View in explorer',
    viewActivity: 'View activity',
    backToConvert: 'Back to swap',
    backToLiquidityForm: 'Back to form',
    swapOperationCancelled: 'You cancelled the operation before it completed.',
    swapCancelledTitle: 'Operation cancelled',
    swapCancelledKicker: 'Swap',
    swapErrorTitle: 'Could not complete swap',
    swapErrorKicker: 'Swap error',
    retrySwapAction: 'Try again',
    goToToken: (symbol: string) => `Go to ${symbol}`,
    newSwap: 'New swap',
    exchangeRate: 'Exchange rate',
    minReceived: 'Minimum received',
    maxSold: 'Maximum sold',
    priceImpact: 'Impact',
    maxPreset: 'Max',
    addLiquidityTitle: 'Add liquidity',
    removeLiquidityTitle: 'Remove liquidity',
    importPoolTitle: 'Import pool',
    reviewAddLiquidity: 'Review deposit',
    reviewRemoveLiquidity: 'Review withdrawal',
    supplyLiquidity: 'Add liquidity',
    confirmSupply: 'Confirm deposit',
    confirmRemove: 'Confirm withdrawal',
    createPoolSupply: 'Create pool and add liquidity',
    removeLiquidity: 'Remove',
    approveToken: (symbol: string) => `Approve ${symbol}`,
    approving: 'Approving…',
    awaitingWalletSignature: 'Waiting for wallet signature',
    awaitingConfirmation: 'Waiting for confirmation',
    firstPoolBanner: 'You are the first liquidity provider.',
    firstPoolHint:
      'The token ratio you add will set the pool price. When you are satisfied, review and confirm.',
    liquidityAddBlockedTitle: 'Add liquidity unavailable',
    liquidityAddBlockedHint: 'This pair does not support adding liquidity right now.',
    liquidityRemoveBlockedTitle: 'Removal unavailable',
    liquidityRemoveBlockedHint: 'This pair does not support removing liquidity right now.',
    swapBlockedTitle: "Don't Panic — this pair isn't on the menu yet",
    swapBlockedHint:
      'The Nutri-Matic is not dispensing this combination for now. Nothing is broken — mostly harmless. Try another pair or check back later.',
    swapTokenBlockedHint: (symbol: string) =>
      `${symbol} is not on the swap menu for this pair yet. Mostly harmless — pick another token or check back soon.`,
    poolShare: 'Pool share',
    initialPrices: 'Initial prices',
    pricesAndShare: 'Prices and share',
    currentPositionTitle: 'Your current position',
    synthesisSummaryTitle: 'Deposit summary',
    withdrawSummaryTitle: 'Withdrawal summary',
    depositAmount: (symbol: string) => `${symbol} deposit`,
    withdrawTokenAmount: (symbol: string) => `You will receive ${symbol}`,
    positionTokenAmount: (symbol: string) => `${symbol} in position`,
    lpBalance: 'LP balance',
    lpToReceive: 'LP to receive',
    currentPoolShare: 'Current share',
    projectedPoolShare: 'Projected share',
    poolRatesTitle: 'Pool prices',
    poolRateLabel: (base: string, quote: string) => `${base} per ${quote}`,
    liquidityMetricsIdle: 'Enter amounts to see projected LP and share.',
    liquidityPositionConnectHint: 'Connect your wallet to see your current position.',
    liquidityRemoveMetricsIdle: 'Enter the percentage to withdraw to see the breakdown.',
    removeAmount: 'Amount to remove',
    youWillReceive: 'You will receive',
    addSuccessTitle: (a: string, b: string) => `Done! You added ${a}/${b} liquidity`,
    removeSuccessTitle: (a: string, b: string) => `Done! You removed ${a}/${b} liquidity`,
    liquidityOperationCancelled: 'You cancelled the operation before it completed.',
    liquidityCancelledTitle: 'Operation cancelled',
    liquidityCancelledAddKicker: 'Liquidity deposit',
    liquidityCancelledRemoveKicker: 'Liquidity withdrawal',
    liquidityErrorTitle: 'Could not complete',
    liquidityErrorAddKicker: 'Add liquidity error',
    liquidityErrorRemoveKicker: 'Remove liquidity error',
    retryLiquidityAction: 'Try again',
    newLiquidityAction: 'New action',
    importSelectToken: 'Select a token to import your pool.',
    importConnectWallet: 'Connect your wallet to import pools.',
    poolFound: 'Pool found',
    importNoPosition: 'You do not have liquidity in this pool yet.',
    importNoPool: 'No pool found.',
    addLiquidityLink: 'Add liquidity',
    createPoolLink: 'Create pool',
  },
  liquidityHub: {
    positionsTitle: 'LP positions',
    readoutKicker: 'Your LP position',
    performKicker: 'Inventory',
    onchainFootnote:
      'Uniswap v2 does not store historical P&L or APR on-chain. Here you see current state: LP balances, share %, and pair reserves via contract.',
    placeholderConnectTitle: 'Connect your wallet',
    placeholderConnectLead:
      'Without an active session the Nutri-Matic cannot read your LP certificates. Connect your wallet to continue.',
    placeholderEmptyTitle: 'Inventory is empty',
    placeholderEmptyLead:
      'No liquidity is registered in your wallet yet. Add liquidity to a new pair or import a pool you have already used.',
    placeholderSelectTitle: 'Choose a position',
    placeholderSelectLead:
      'Select a pair from the inventory to show your share, reserves, and spot price in the readout panel.',
    placeholderLoadingTitle: 'Syncing with the network',
    placeholderLoadingLead: 'Fetching LP balances on-chain. Don\'t panic.',
    actionAdd: 'Add liquidity',
    actionImport: 'Import pool',
    actionAddPair: 'Add to pair',
    actionRemovePair: 'Remove from pair',
    backToPositions: 'LP positions',
    mobileEmptyConnect: 'Connect your wallet to see liquidity positions.',
    mobileEmptyPositions: 'You have no visible LP positions.',
    mobileLoading: 'Loading positions…',
  },
} as const
